// JsFromRoutes CacheKey 5f1d78a95161e40bdbbb6172e2edb888
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  create: /* #__PURE__ */ definePathHelper("post", "/api/media"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/media/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/media/:id"),
}
